export * from './database';
export * from './list/changes';
export * from './list/create-reference';
export * from './list/snapshot-changes';
export * from './list/state-changes';
export * from './list/audit-trail';
export * from './observable/fromRef';
export * from './database.module';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/~/angularfire2/database/public_api.js
// module id = ../../../../angularfire2/database/public_api.js
// module chunks = 4